//======> Docementation <======//
registerBlockType('tornado/landing-slider', {
    title: __('landing slider', 'tornado'),
    description: __('landing slider', 'tornado'),
    icon:'feedback',
    category: 'tornado',
    keywords: [ 'tornado', 'section' ],
    supports: {
        align: ['full','wide']
    },
    attributes: {
     
    },
    //==== Editing Mode ====//
    edit: props => {
        //==== Block Data ====//
        const { attributes, setAttributes } = props;
        props.setAttributes( { align: 'full' } );
        //==== Main ====//
        
        //==== Block Structure ====//
        return (
            <Panel>
                <PanelBody>
                  
                    <div className="hero-slider tx-align-center">
                        <InnerBlocks allowedBlocks={ 'tornado/landing-slider-content' } />
                    </div>            
                </PanelBody>
            </Panel>
        );
    },
    //==== Puplish Mode ====//
    save: props => {
        //==== Block Data ====//
        const { attributes } = props;

        //==== Block Structure ====//
        return (
                <div className="hero-slider tx-align-center">
                    <InnerBlocks.Content />
                </div>
        );
    },
});